import { getRoot, types, Instance } from "mobx-state-tree";
import { Agent, IAgent } from "./Agent";

/**
 * TODO: docstring
 */
export const AgentReferenceType = types.reference(Agent, {
  get(id: string, parent: any) {
    // FIXME: `any` to avoid self-reference issue
    const { agentStore } = getRoot(parent) as any;
    return agentStore.getOrLoad(id) as IAgent;
  },
  set(agent: IAgent) {
    return (agent && agent.id) || "";
  }
});

export interface IAgentReferenceType extends Instance<typeof AgentReferenceType> {}
